/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = window.location.pathname;

	// FAQトグル
	const faqToggle = (e) => {
		const faq = document.querySelectorAll('.js-faq-btn');
		if (!faq) return;
		faq.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const target = e.currentTarget;
				const faqContent = target.nextElementSibling;

				if (target.classList.contains(a)) {
					target.classList.remove(a);
					faqContent.style.height = '0';
				} else {
					target.classList.add(a);
					faqContent.style.height = faqContent.scrollHeight + 'px';
				}
			});
		});
	};

	// その他のご質問カテゴリ
	const faqCategory = () => {
		const categoryBtn = document.querySelectorAll('.js-faq-category');
		if (!categoryBtn) return;
		categoryBtn.forEach((el) => {
			if(el.getAttribute('href') === $path || el.getAttribute('href') + 'index.html' === $path) {
				el.parentElement.remove();
			}
		});
	};

	// ============ ↑↑ FUNCTIONS ↑↑ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	faqToggle();
	faqCategory();

})(window.FUNCTIONS);
